import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  onRefresh = new Subject();
  constructor(private http: HttpClient) {}

  ping() {
    return this.http.get(`${environment.apiUrl}/ping`).pipe();
  }

  login(data) {
    return this.http
      .post(`${environment.apiUrl}/rider/authenticate`, data)
      .pipe();
  }

  forgotPassword(data) {
    return this.http
      .put(`${environment.apiUrl}/rider/forgot-password`, data)
      .pipe();
  }

  register(data) {
    return this.http.post(`${environment.apiUrl}/rider/register`, data).pipe();
  }

  subscribeTopic(data) {
    return this.http
      .put(`${environment.apiUrl}/rider/subscribe-topic`, data)
      .pipe();
  }

  unsubscribeTopic(data) {
    return this.http
      .put(`${environment.apiUrl}/rider/unsubscribe-topic`, data)
      .pipe();
  }

  subscribeTeamTopic(data) {
    return this.http
      .put(`${environment.apiUrl}/rider/subscribe-team-topic`, data)
      .pipe();
  }

  unsubscribeTeamTopic(data) {
    return this.http
      .put(`${environment.apiUrl}/rider/unsubscribe-team-topic`, data)
      .pipe();
  }

  changeName(data) {
    return this.http
      .put(`${environment.apiUrl}/rider/change-name`, data)
      .pipe();
  }

  changePassword(data) {
    return this.http
      .put(`${environment.apiUrl}/rider/reset-password`, data)
      .pipe();
  }

  refreshToken() {
    return this.http.get(`${environment.apiUrl}/rider/refresh-token`).pipe();
  }

  addToTeam(special_id) {
    return this.http
      .get(`${environment.apiUrl}/rider/add-to-team/${special_id}`)
      .pipe();
  }

  removeFromTeam(id) {
    return this.http
      .get(`${environment.apiUrl}/rider/remove-from-team/${id}`)
      .pipe();
  }

  getAllTeamMembers(data) {
    return this.http.post(`${environment.apiUrl}/rider/get-team`, data).pipe();
  }

  acceptTeam() {
    return this.http.get(`${environment.apiUrl}/rider/accept-team`).pipe();
  }

  rejectTeam() {
    return this.http.get(`${environment.apiUrl}/rider/reject-team`).pipe();
  }

  leaveTeam() {
    return this.http.get(`${environment.apiUrl}/rider/leave-team`).pipe();
  }

  getLatestVersion() {
    return this.http.get(`${environment.apiUrl}/rider/version/latest`).pipe();
  }

  getTeamLeader() {
    return this.http.get(`${environment.apiUrl}/rider/team-leader`).pipe();
  }
}
